import { toCanvas } from "html-to-image";

const BLANK = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

const settle = (img) => img.complete ? null : new Promise((resolve) => {
  img.addEventListener("load", resolve, { once: true });
  img.addEventListener("error", resolve, { once: true });
  setTimeout(resolve, 8000);
});

const isBroken = (n) => n instanceof HTMLImageElement && n.complete && n.naturalWidth === 0;

export const renderPoster = async (node, opts) => {
  await document.fonts.ready;
  await Promise.all([...node.querySelectorAll("img")].map(settle));
  const full = { ...opts, imagePlaceholder: BLANK, filter: (n) => !isBroken(n) };
  await toCanvas(node, full);
  return toCanvas(node, full);
};

export const uploadSnapshot = async (api, posterId, node, height, kind) => {
  const canvas = await renderPoster(node, { pixelRatio: kind === "a4" ? 2.6 : 1.5, width: 1280, height, backgroundColor: "#0b1a3a", cacheBust: true });
  const blob = await new Promise((resolve) => canvas.toBlob(resolve, "image/jpeg", 0.9));
  const form = new FormData();
  form.append("file", blob, `${kind}.jpg`);
  form.append("kind", kind);
  await api.post(`/posters/${posterId}/snapshot`, form, { headers: { "Content-Type": "multipart/form-data" } });
};
